import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  reportFormData: {},
  reportBuilderData: {report_name: null, report_desc: null, module: null, subModule: null, report_type: null, conditions: [], columns: []},
  assigned_users: [],
  action: null,
  isReset: null
};

const reportBuilderSlice = createSlice({
  name: 'reportBuilderSlice',
  initialState,
  reducers: {
    setReportFormData: (state, action) => {
        state.reportFormData = action.payload;
    },
    setReportBuilderData: (state, action) => {
        state.reportBuilderData = action.payload;
    },
    setAssignedUserData: (state, action) => {
        state.assigned_users = action.payload;
    },
    setAction: (state, action) => {
      state.action = action.payload;
  },
    setIsReset: (state, action) => {
      state.isReset = action.payload;
  },
  resetState: (state) => {
    return {...initialState, action: state.action};
  },
  patchReportData: (state, action: PayloadAction<any>) => {
    state.reportFormData = action?.payload?.reportFormData;
    state.reportBuilderData = action?.payload?.reportBuilderData;
    state.assigned_users = action?.payload?.assigned_users;
    state.action = action?.payload?.action;
  },
  },
});

export const { setReportFormData, setReportBuilderData, setAssignedUserData, setAction, setIsReset, resetState, patchReportData } = reportBuilderSlice.actions;

export default reportBuilderSlice.reducer;
